import React from 'react';
import {connect} from 'react-redux';
import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import lifecycle from 'recompose/lifecycle';
import {withRouter} from 'react-router-dom';
import * as ResourceApi from 'api/resources';
import DocumentTitle from 'react-document-title';
import setDisplayName from 'recompose/setDisplayName';
import ItemExplorer from 'components/common/ItemExplorer';
import SecretSonicSpinner from 'components/common/SecretSonicSpinner';
import {openPrizeChallengesModal} from 'components/PrizeChallengesModal/actions';
import PrizeChallengesModal from 'components/PrizeChallengesModal/PrizeChallengesModal';
import ReportDownloadStatusModal from 'components/modals/ReportDownloadStatusModal';
import {createResourceSortsSelector, createResourceSortOptionsSelector} from 'viewOptions/selectors';
import {removeAllFiltersForResourceAction, toggleSortForResourceAction} from 'viewOptions/actions';
import {updatePageNumberForResourceAction} from 'resources/actions';
import EntriesPageHeader from './EntriesPageHeader';
import {needsWinnersManuallySelected} from './utils';
import entriesTableConfigs from './configs';
import * as EntriesActions from './actions';
import {
  createResourceSelector,
  createResourcePageSelector,
  createResourcePageItemsSelector
} from 'resources/selectors';
import {
  EmptyFunc,
  SortDirection,
  ItemExplorerViewOptions,
  pageCount,
  prependRecentIfFirstPage
} from 'utils/DBUtils';
import ManualEntryModal from "./ManualEntryModal";

const getResourcePage = createResourcePageSelector(ResourceApi.Types.PrizeEntry);
const getPageItems = createResourcePageItemsSelector(ResourceApi.Types.PrizeEntry);
const getSorts = createResourceSortsSelector(ResourceApi.Types.PrizeEntry);
const getSortOptions = createResourceSortOptionsSelector(ResourceApi.Types.PrizeEntry);

const mapStateToProps = state => {
  const {fetchingEntries, fetchingPrize, selectingWinners, currentPrizeId} = state.listEntries;
  const loading = fetchingEntries || fetchingPrize;

  const getPrize = createResourceSelector(currentPrizeId);
  const prize = getPrize(state.resources) || {};

  const resourcePage = getResourcePage(state.resources);
  const pageSize = resourcePage.count;
  const currentPage = resourcePage.page;
  const totalEntries = resourcePage.total;

  return {
    loading,
    selectingWinners,
    prize,
    isPrizeChallengesModalOpen: state.prizeChallengesModal.isOpen,
    entries: prependRecentIfFirstPage(currentPage, pageSize, [], getPageItems(state.resources)),
    currentPage,
    pageSize,
    totalEntries,
    sortOptions: getSortOptions(state),
    getSortDirectionForField: field => getSorts(state)[field] || SortDirection.Unsorted,
    reportResponses : state.listEntries.reportResponses
  };
};

const mapDispatchToProps = {
  startManualEntry: EntriesActions.startManualEntryAction,
  openPrizeChallengesModal,
  requestEntries: EntriesActions.requestEntriesAction,
  submitSelectWinners: EntriesActions.submitSelectWinnersAction,
  downloadReport: EntriesActions.downloadReportAction,
  onPageSelected: page => updatePageNumberForResourceAction(ResourceApi.Types.PrizeEntry, page, {winnersOnly: false}),
  onNextClicked: currentPage => updatePageNumberForResourceAction(ResourceApi.Types.PrizeEntry, currentPage+1, {winnersOnly: false}),
  onPreviousClicked: currentPage => updatePageNumberForResourceAction(ResourceApi.Types.PrizeEntry, currentPage-1, {winnersOnly: false}),
  selectSort: field => toggleSortForResourceAction(ResourceApi.Types.PrizeEntry, field, {winnersOnly: false}),
  clearDownloadModal: EntriesActions.downloadReportClearModalAction
};

const ListEntriesTable = compose(
  setDisplayName('ListEntriesTable'),
  withProps(props => ({
    showView: ItemExplorerViewOptions.List,
    itemsOnly: true,
    filterBarProps: {
      hidden: true
    },
    pagingBarProps: {
      count: pageCount(props.totalEntries, props.pageSize),
      total: props.totalEntries,
      currentPage: props.currentPage,
      maxPages: 10,
      onPageSelected: props.onPageSelected,
      onNextClicked: props.onNextClicked,
      onPreviousClicked: props.onPreviousClicked
    },
    tableProps: {
      scrolling: true,
      items: props.entries.map(entry => {
        if (!entry.prize) {
          console.warn(`PrizeEntry with id '${entry.id}' has no 'prize' property.`);
        }

        return entry;
      }),
      onRowClicked: EmptyFunc,
      getSortDirectionForField: props.getSortDirectionForField,
      onSortClick: col => {
        if (col.fieldName) {
          props.selectSort(col.fieldName);
        }
      },
      colDetails: props.entriesTableConfig.columns.map(col => col(props))
    },
    clearDownloadDialog: () => {

    }
  }))
)(ItemExplorer);

export default compose(
  setDisplayName('ListEntriesPage'),
  connect(mapStateToProps, mapDispatchToProps),
  withRouter,
  withProps(props => {
    const {prizeId, prizeType} = props.match.params;
    const entriesTableConfig = entriesTableConfigs[prizeType];

    return {
      prizeId,
      prizeType,
      entriesTableConfig,
      selectWinners: () => props.submitSelectWinners(props.prize.id),
      allowSelectWinners: needsWinnersManuallySelected(props.prize),
      downloadReport: () => props.downloadReport(props.prize.id),

    };
  }),
  lifecycle({
    componentWillMount() {
      this.props.requestEntries(this.props.prizeId);
    },
    componentWillReceiveProps(nextProps) {
      const prizeChanged = nextProps.prizeId !== this.props.prizeId;
      if (prizeChanged) {
        this.props.requestEntries(nextProps.prizeId);
      }
    }
  })
)(props => (
  <DocumentTitle title={props.entriesTableConfig.documentTitle}>
    <div className={`list-entries-page ${props.entriesTableConfig.topLevelClassName}`}>
      <EntriesPageHeader {...props} />
      <ReportDownloadStatusModal
          onClose={ () => { 
            props.clearDownloadModal()
          }}
          reportResponses={ props.reportResponses } />
          
      {props.loading ? <SecretSonicSpinner messageKey={props.entriesTableConfig.spinnerMessage} /> : (
        <React.Fragment>
          <ListEntriesTable {...props} />
          {props.isPrizeChallengesModalOpen && <PrizeChallengesModal />}
        </React.Fragment>
      )}
      <ManualEntryModal/>
    </div>
  </DocumentTitle>
));



// WEBPACK FOOTER //
// ./public/pages/ListEntries/ListEntriesPage.jsx